import {
  homePath,
  exchangeSchoolYearPath,
  teachersPath,
  classesPath,
  studentsPath,
  subjectsPath,
  subClassesPath,
  uploadStudentRealPhotosPath,
  useHistoriesPath,
  gearStatusPath,
  notificationsPath,
  contractManagementPath,
} from "../managerStore";
import { NavItemKey, NavItem, NavSection } from "../state";

import { titles } from "./titles";

export const NAV_ITEMS: Record<NavItemKey, NavItem> = {
  home: {
    labels: { school: titles.home },
    link: homePath,
  },
  exchangeSchoolYear: {
    labels: { school: titles.exchangeSchoolYear },
    link: exchangeSchoolYearPath,
  },
  teachers: {
    labels: { school: titles.teachers },
    link: teachersPath,
  },
  classes: {
    labels: { school: titles.classes },
    link: classesPath,
  },
  students: {
    labels: { school: titles.students, cram_school: titles.cramSchoolStudents },
    link: studentsPath,
  },
  subjects: {
    labels: { school: titles.subjects },
    link: subjectsPath,
  },
  studentPhotos: {
    labels: { school: titles.studentPhotos },
    link: uploadStudentRealPhotosPath,
  },
  subClasses: {
    labels: { school: titles.subClasses },
    link: subClassesPath,
  },
  useHistories: {
    labels: { school: titles.useHistories },
    link: useHistoriesPath,
  },
  gearStatus: {
    labels: { school: titles.gearStatus },
    link: gearStatusPath,
  },
  notifications: {
    labels: { school: titles.notifications },
    link: notificationsPath,
  },
  contractManagement: {
    labels: { school: titles.contractManagement },
    link: contractManagementPath,
  },
};

export const REGISTRATION_STEPS_REQUIRED_LABEL = "基本登録（必須）";
export const REGISTRATION_STEPS_OPTIONAL_LABEL = "追加登録（任意）";
export const MANAGE_LABEL = "管理メニュー";

export const REGISTRATION_STEPS_REQUIRED: NavSection = {
  kind: "required",
  label: REGISTRATION_STEPS_REQUIRED_LABEL,
  navItemKeys: ["teachers", "classes", "students", "subjects"],
};

export const REGISTRATION_STEPS_REQUIRED_DLP_ONLY: NavSection = {
  kind: "required",
  label: REGISTRATION_STEPS_REQUIRED_LABEL,
  navItemKeys: ["teachers", "classes", "students"],
};

export const REGISTRATION_STEPS_OPTIONAL: NavSection = {
  kind: "optional",
  label: REGISTRATION_STEPS_OPTIONAL_LABEL,
  navItemKeys: ["studentPhotos", "subClasses"],
};

export const MANAGE: NavSection = {
  kind: "manage",
  label: MANAGE_LABEL,
  navItemKeys: [
    "useHistories",
    "gearStatus",
    "notifications",
    "contractManagement",
  ],
};

export const MANAGE_DLP_ONLY: NavSection = {
  ...MANAGE,
  navItemKeys: ["contractManagement"],
};
